export default __webpack_public_path__ + "static/media/feedbacks-icons.9936abcb.png";